import { trpc } from "@/api/client";
import { useSelectedCompany } from "@flash-tecnologia/hros-web-utility";
import { RoleBuiltInIds } from "../types";

export const useGetPermissionsRoles = () => {
  const { selectedCompany } = useSelectedCompany();
  const { data: permissionRoles, isLoading } = trpc.getPermissionRoles.useQuery(
    {
      companyId: selectedCompany.id,
      builtInIds: [
        RoleBuiltInIds.ADMIN,
        RoleBuiltInIds.BENEFIT_ADMIN,
        RoleBuiltInIds.EXPENSE_ADMIN,
      ],
    },
    { enabled: !!selectedCompany.id, networkMode: "offlineFirst" }
  );

  return { permissionRoles, isLoading };
};
